import {z} from 'zod'
import {AddressModel} from './address.js'
import {ColloModel, OrderAddressModel} from './order.js'

const RouteAddressModel = OrderAddressModel.extend({
    id: z.string(),
    isDepot: z.boolean(),
    orderId: z.string(),
    previousId: z.string(),
    routeId: z.string(),
    routeOrder: z.number(),
    routeNumber: z.number(),
    addressOrder: z.string(),
    added: z.boolean(),
    originalIndex: z.number(),
    customerAddress: AddressModel,
    senderAddress: AddressModel,
    colli: z.array(ColloModel),
    status: z.number().optional(),
    completedAt: z.string().optional()
})

const RouteGeometryModel = z.object({
    type: z.string(),
    coordinates: z.array(z.array(z.number()))
})

const NewRouteModel = z.object({
    reseller: z.string(),
    branchId: z.string().max(100).optional(),
    name: z.string(),
    date: z.string(),
    rrule: z.string().optional(),
    messengerId: z.string(),
    color: z.string(),
    startTime: z.string(),
    plannedStartTime: z.string(),
    endTime: z.string(),
    plannedEndTime: z.string(),
    estimatedEndTime: z.string(),
    // Start (HH:mm) the optimiser advises with time slots: later than plannedStartTime (or the moment of
    // optimising, without one) when the first time slots open later, earlier when that avoids arriving late;
    // set on optimisation, cleared on any other recalculation
    suggestedStartTime: z.string().optional(),
    completedTime: z.string().optional(),
    startPoint: RouteAddressModel,
    endPoint: RouteAddressModel,
    vehicleType: z.string(),
    vehicleId: z.string(),
    vehicleTypeId: z.string(),
    customSpeed: z.boolean(),
    speedDifference: z.number(),
    stopTime: z.number(),
    instructions: z.string(),
    optimizeForTimeslots: z.boolean().optional(),
    optimizeForCapacity: z.boolean().optional(),
    maxDuration: z.number().optional(),
    maxEndTime: z.string().optional(),
    adjustableByMessengerGrouped: z.enum(['default', 'yes', 'no']).default('default'),
    adjustableByMessenger: z.boolean().default(false),
    allowAddAddress: z.boolean().default(false),
    allowAddCollo: z.enum(['yes', 'deliver', 'pickup', '']).default(''),
    messengerAddOrderWarning: z.enum(['allowed', 'only_today', 'only_unplanned', 'only_unplanned_today', 'notallowed']).default('notallowed'),
    showWarningOnAddExistingOrder: z.boolean().default(false),
    allowMessengerEditCustomOptions: z.boolean().default(false),
    loadingRequiredBeforeStart: z.boolean().default(false),
    anchorsEnabled: z.boolean().optional(),
    completedAddresses: z.array(RouteAddressModel),
    completedColli: z.array(ColloModel),
    orderIds: z.array(z.string()),
    addresses: z.array(RouteAddressModel),
    colli: z.array(ColloModel),
    distance: z.number(),
    duration: z.number(),
    plannedDistance: z.number(),
    completedDistance: z.number(),
    plannedDuration: z.number(),
    geometry: RouteGeometryModel,
    completedGeometry: RouteGeometryModel,
    ready: z.boolean(),
    loaded: z.boolean(),
    started: z.boolean(),
    completed: z.boolean(),
    notCompleted: z.number(),
    success: z.number(),
    tooLate: z.number(),
    delay: z.number(),
    templateId: z.string().optional(),
    messengerLocation: z.object({
        lat: z.number(),
        lng: z.number(),
        // When the courier app sent the position, the Track & Trace map hides an old one
        timestamp: z.string().optional()
    }).optional(),
    // When the ETA was last recalculated from the messenger's position
    etaUpdatedAt: z.string().optional()
})

const RouteModel = NewRouteModel.extend({
    _id: z.string()
})

export {RouteModel, NewRouteModel, RouteAddressModel, RouteGeometryModel}
